import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, Toast, Typography } from '@chilecompra/react-kit'
import { PUBLIC_URL } from '../../config/settings/environment'
import {
  ButtonConfirmModal,
  ButtonExitModal,
  ButtonRecalculate,
  ContentButtonActualization,
  DialogContent,
  DialogIcon,
  DialogMessage,
  HelpIcon,
  RefreshIcon,
  Strong,
  Tooltip,
  TooltipIcon
} from './AbilityStatusSection.styles'

/**
 * RecalculateAbility's section component
 */
const RecalculateAbilitySection = props => {
  const {
    loading,
    handleDialogOpen,
    showDialog,
    handleDialogClose,
    numberPerDay,
    handleConfirmRecalculateDialog,
    recalculateAbilityButton
  } = props

  return (
    recalculateAbilityButton.isActive && (
      <ContentButtonActualization>
        {recalculateAbilityButton.isActive && recalculateAbilityButton.error === undefined && (
          <>
            <ButtonRecalculate
              disabled={loading}
              color="default"
              margin="0 17px 0 0"
              variant="outlined"
              onClick={handleDialogOpen}
            >
              Solicitar actualización de estado
              <RefreshIcon alt="recalculate" />
            </ButtonRecalculate>
            <Tooltip
              content={
                <Typography color="white" variant="subtitle1">
                  Esta permite verificar el estado de habilidad de tu empresa para actualizarlo en Mercado Público. El
                  proceso puede tardar, ya que la información proviene de diversas fuentes.
                </Typography>
              }
            >
              <TooltipIcon>
                <HelpIcon />
              </TooltipIcon>
            </Tooltip>
          </>
        )}
        {!recalculateAbilityButton.isActive && recalculateAbilityButton.nextDisplay && (
          <Toast border severity="default" textDirection="vertical">
            La solicitud para actualizar el estado de habilidad de tu empresa <Strong>ha sido enviada</Strong>, te
            notificaremos cuando finalice. Podrás volver a solicitarla el{' '}
            <Strong>{recalculateAbilityButton.nextDisplay}</Strong>.
          </Toast>
        )}
        {recalculateAbilityButton.error && (
          <Toast border severity="error" textDirection="vertical">
            Estamos presentando problemas para realizar tu solicitud . Espera unos segundos e inténtalo nuevamente.
          </Toast>
        )}
        {/* Confirmation Recalculate Process Modal */}
        <Dialog maxWidth="580px" open={showDialog} onClose={handleDialogClose}>
          <DialogContent>
            <DialogIcon alt="Cambios guardados" src={`${PUBLIC_URL}/assets/images/circle-warning-icon.svg`} />
            <DialogMessage>
              <Typography fontWeight="bold" variant="h4">
                Estás por solicitar la actualización del estado de habilidad
              </Typography>
              <Typography margin="16px 0 0" variant="body2">
                Al realizar esta acción <Strong> se volverá a verificar el estado de habilidad de tu empresa </Strong>{' '}
                para actualizarlo en Mercado Público. El proceso puede tardar, ya que la información proviene de
                diversas fuentes. Solo podrás realizar esta solicitud {numberPerDay} veces al día ¿deseas continuar?
              </Typography>
              <ButtonExitModal
                disabled={loading}
                loading={loading}
                margin="28px 0 0 0"
                variant="contained"
                onClick={handleDialogClose}
              >
                Cerrar
              </ButtonExitModal>
              <ButtonConfirmModal
                color="primary"
                disabled={loading}
                loading={loading}
                margin="28px 0 0 20px"
                variant="contained"
                onClick={handleConfirmRecalculateDialog}
              >
                Solicitar actualización
              </ButtonConfirmModal>
            </DialogMessage>
          </DialogContent>
        </Dialog>
      </ContentButtonActualization>
    )
  )
}

RecalculateAbilitySection.propTypes = {
  loading: PropTypes.bool,
  recalculateAbilityButton: PropTypes.object,
  handleDialogOpen: PropTypes.func,
  showDialog: PropTypes.bool,
  handleDialogClose: PropTypes.func,
  numberPerDay: PropTypes.number,
  handleConfirmRecalculateDialog: PropTypes.func
}

export default RecalculateAbilitySection
